import React from 'react';
import { PlayerHeaderTabNg } from '@/src/right-column-ng/components/PlayerHeaderTabNg';
import { MATCHTRACKER, VIDEO } from '@/src/player/services/tabConstants';
import { SvgIcon } from 'commons/js/components/SvgIcon';
import { useReframe } from 'nike-re-framejs';
import { getBetradarPlayerActiveTab$, getMatch$ } from '@/src/infocentrum/subs';
import i18n from '@i18n';
import { isRadarStream, isVideoStream } from 'nike-ui/src/components/turboLive/push/overview/handlers';
import { useIsBetradarWidgetAvailable } from 'nike-ui/src/components/match-statistics/hooks/useIsBetradarWidgetAvailable';

function RightColumnStreamsTabs() {
    const derefSub = useReframe();
    const activeTab = derefSub(getBetradarPlayerActiveTab$);
    const match = derefSub(getMatch$);
    const hasVideo = isVideoStream(match);
    const isMatchLive = match?.get('isLive');
    const hasRadar = isRadarStream(match);
    const isBrAvaiable = useIsBetradarWidgetAvailable(match);
    const isBrEnabled = hasRadar && isBrAvaiable;
    const activeVideo = activeTab === VIDEO;
    const activeRadar = activeTab === MATCHTRACKER;
    const videoTitle = activeVideo ? 'infocentre.video.hide' : 'infocentre.video.show';
    const radarTitle = activeRadar ? 'infocentre.radar.hide' : 'infocentre.radar.show';

    return hasVideo || hasRadar ? (
        <div className="flex bg-black-20">
            {hasVideo && isMatchLive && (
                <PlayerHeaderTabNg
                    name={VIDEO}
                    match={match}
                    data-atid={`infocentrum-player-tab-${VIDEO}`}
                    isEnabled={hasVideo}
                    isActive={activeVideo}
                    title={i18n(videoTitle)}
                >
                    <SvgIcon imgId="live-play-stream" className="c-white mx-2" sizeX="20" sizeY="12" />
                </PlayerHeaderTabNg>
            )}
            {isBrEnabled && (
                <PlayerHeaderTabNg
                    name={MATCHTRACKER}
                    match={match}
                    data-atid={`infocentrum-player-tab-${MATCHTRACKER}`}
                    isEnabled
                    isActive={activeRadar}
                    title={i18n(radarTitle)}
                >
                    <SvgIcon imgId="live-play-radar" className="c-white mx-2" sizeX="20" sizeY="12" />
                </PlayerHeaderTabNg>
            )}
        </div>
    ) : null;
}

export default RightColumnStreamsTabs;
